import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_TRIALITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
    ACTION_TRIALITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE
} from '../../actions/pages/trialItemsPage';


export interface ITrialItemsPageState {
    editModalOpen: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
    createVersionModalOpen: boolean;
    trialItem: Dtos.TrialItem
}

const initialState: ITrialItemsPageState = {
    editModalOpen: false,
    collectionInstanceId: null,
    name: "",
    description: "",
    createVersionModalOpen: false,
    trialItem: null
};


function setEditModalViewState(state: ITrialItemsPageState, open: boolean, collectionInstanceId: number, name: string, description: string): ITrialItemsPageState {
    const newState: ITrialItemsPageState = update(state, {
        editModalOpen: {
            $set: open
        },
        collectionInstanceId: {
            $set: collectionInstanceId
        },
        name: {
            $set: name
        },
        description: {
            $set: description
        }
    });
    return newState;
}

function setCreateVersionModalViewState(state: ITrialItemsPageState, open: boolean, trialItem: Dtos.TrialItem): ITrialItemsPageState {
    const newState: ITrialItemsPageState = update(state, {
        createVersionModalOpen: {
            $set: open
        },
        trialItem: {
            $set: trialItem
        }
    });
    return newState;
}

const TrialItemsPageReducer: Reducer<ITrialItemsPageState> = (state: ITrialItemsPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_TRIALITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE:
            return setEditModalViewState(state, action.open, action.collectionInstanceId, action.name, action.description);
        case ACTION_TRIALITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE:
            return setCreateVersionModalViewState(state, action.open, action.trialItem);
    }

    return state;
}

export default TrialItemsPageReducer;